export const OPEN_INFO_TYPE = 'type';
export const OPEN_INFO_CREATED_AT = 'created_at';
export const OPEN_INFO_FILES = 'files';
export const OPEN_INFO_TITLE = 'title_json';
export const OPEN_INFO_FILE_ID = 'file_id';
